//types
export const CURRENT_MODEL = 'PROJECT/CURRENT_PROJECT_MODEL';

//setter
export const setCurrentModel = model => ({ type: CURRENT_MODEL, model});